<template>
  <div class="launch">
    <p style="font-size: 32px">Payers</p>
    <p>Create Payer</p>
    <div class="input" style="margin-top: 5px;">
      <input v-model="privateKey" placeholder="Input Private Key" />
    </div>

    <select style="margin-top: 10px; width: 100%;" v-model="payerID">
      <option v-for="i of payers" :key="i.id" :value="i.id">{{ i.publicKey }}</option>
    </select>
    <div class="create-buttons">
      <button class="button" @click="createPayer" style="flex: 1;">Create</button>
      <button class="button" @click="createNewPayer" style="flex: 1;">Create New Payer</button>
    </div>

    <p style="font-weight: bold; margin-top: 15px;">All payers</p>

    <div class="payersList">
      <div class="infoWallets payer-header">
        <p>Address</p>
        <p>Balance</p>
        <p></p>
      </div>
      <div class="infoWallets" v-for="item in payers" :key="item.id">
        <a :href="`https://solscan.io/account/${item.publicKey}`" target="_blank" rel="noopener noreferrer" style="color: #60cb89;">
          {{ item.publicKey.slice(0, 4) }}...{{ item.publicKey.slice(-4) }}
        </a>
        <p :style="item.balanceSol > 0 ? 'color: #60cb89;' : ''">
          {{ item.balanceSol != null ? item.balanceSol.toFixed(4) : "..." }} SOL
        </p>
        <div style="display: flex; gap: 5px; justify-content: flex-end;">
          <button class="button sm" @click="copyPrivateKey(item.privateKey)">PK</button>
          <button class="button sm" @click="openTransfer(item)">Send</button>
          <button class="button sm red" @click="deleteWallet(item.id)">&times;</button>
        </div>
      </div>
    </div>

    <div class="modal-overlay" v-if="transferPayer" @click.self="transferPayer = null">
      <div class="modal-box">
        <p style="font-family: 'Proxima Nova Bold'; font-size: 20px;">Transfer SOL</p>
        <p style="font-size: 13px; color: #888; margin-top: 5px;">
          From: {{ transferPayer.publicKey.slice(0, 6) }}...{{ transferPayer.publicKey.slice(-6) }}
          ({{ transferPayer.balanceSol != null ? transferPayer.balanceSol.toFixed(4) : "?" }} SOL)
        </p>
        <div class="input" style="margin-top: 10px;">
          <input v-model="transferDestination" placeholder="Destination address" />
        </div>
        <div class="input" style="margin-top: 8px;">
          <input v-model="transferAmount" type="number" step="0.001" placeholder="SOL amount" />
        </div>
        <div class="create-buttons" style="margin-top: 10px;">
          <button class="button" style="flex: 1;" @click="sendTransfer" :disabled="transferLoading">{{ transferLoading ? "Sending..." : "Send" }}</button>
          <button class="button" style="flex: 1; background-color: #444;" @click="transferPayer = null">Cancel</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { connection } from "@/services/solanaClient";
import { LAMPORTS_PER_SOL, PublicKey } from "@solana/web3.js";
import axios from "axios"
  import { useToast } from "vue-toastification"

  export default {
    name: "PayersComponent",
    data() {
      return {
        privateKey: "",
        payers: [],
        payerID: {},
        payerPublicKey: null,
        transferPayer: null,
        transferDestination: "",
        transferAmount: "",
        transferLoading: false,
      }
    },
    methods: {
      createPayer() {
        axios
          .post(
            `${process.env.VUE_APP_SERVERHOST}/api/wallet/import-payer`,
            {
              privateKey: this.privateKey,
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
              },
            }
          )
          .then((res) => {
            console.log(res)
            this.toast.success("Payer created successfully!", {
              timeout: 2000,
            })
            this.getPayers()
          })
          .catch((err) => {
            console.log(err)
            this.toast.error(err.response.data.message, {
              timeout: 2000,
            })
          })
      },
      async fetchPayerBalances(payers) {
        const balances = await Promise.all(
          payers.map(async (p) => {
            try {
              const lamports = await connection.getBalance(new PublicKey(p.publicKey), "confirmed")
              return { ...p, balanceSol: lamports / LAMPORTS_PER_SOL }
            } catch (e) {
              return { ...p, balanceSol: null }
            }
          })
        )

        return balances
      },
      getPayers() {
        axios
          .get(`${process.env.VUE_APP_SERVERHOST}/api/wallet/payers`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          })
          .then(async (res) => {
            const payers = Array.isArray(res.data) ? res.data : []
            this.payers = await this.fetchPayerBalances(payers.reverse())
            this.payerID = this.payers[0].id
            this.payerPublicKey = this.payers[0].publicKey
          })
          .catch((err) => {
            console.log(err)
          })
      },
      async deleteWallet (id) {
        const res = await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/wallet/hide-wallet`,           
        {
          id
        },
        {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        })
        if(res.data.id) {
          this.getPayers()
            this.toast.success("Payer deleted successfully!", {
              timeout: 2000,
            })
        }
      },
      async createNewPayer () {
        const res = await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/token/create-payer`, {
          oldPayerId: this.payerID
        }, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`
          }
        })

        if(res.data.id) {
          this.payers = await this.fetchPayerBalances([res.data, ...this.payers])
          this.toast.success("Payer created successfully!", {
            timeout: 2000,
          })
        }
      },

      async copyPrivateKey(pk) {
        try {
          await navigator.clipboard.writeText(pk)
          this.toast.success("Private key copied!", { timeout: 1500 })
        } catch (e) {
          this.toast.error("Failed to copy", { timeout: 1500 })
        }
      },

      openTransfer(payer) {
        this.transferPayer = payer;
        this.transferDestination = "";
        this.transferAmount = "";
      },

      async sendTransfer() {
        if (!this.transferDestination || !this.transferAmount) {
          this.toast.error("Fill in all fields", { timeout: 1500 });
          return;
        }
        this.transferLoading = true;
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_SERVERHOST}/api/wallet/transfer`,
            {
              payerId: this.transferPayer.id,
              destinationPublicKey: this.transferDestination,
              solAmount: String(this.transferAmount),
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
              },
            }
          );
          this.toast.success(`Sent ${res.data.amount} SOL to ${res.data.to.slice(0, 8)}...`, { timeout: 3000 });
          this.transferPayer = null;
          this.getPayers();
        } catch (err) {
          const msg = err.response?.data?.message || err.message || "Transfer failed";
          this.toast.error(msg, { timeout: 3000 });
        } finally {
          this.transferLoading = false;
        }
      },
    
    },
    
    mounted() {
      this.getPayers()
    },
    setup() {
      const toast = useToast()
      return { toast }
    },
  }
</script>

<style scoped>
  .launch {
    width: 30% !important;
    margin: 0 auto;
    max-height: 80vh;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    padding: 2%;
    background-color: #191919;
    border-radius: 14px;
    text-align: left;
    filter: drop-shadow(0 0 6px #191919);
  }
  .payersList {
    display: flex;
    flex-direction: column;
    max-height: 50vh;
    overflow-y: auto;
  }
  .infoWallets {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: left;
    font-size: 12px;
    gap: 5px;
    align-items: center;
    border-bottom: 1px solid #60cb8943;
    padding: 8px 0;
  }
  .payer-header {
    font-weight: bold;
  }
  .create-buttons {
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
  }
  .input {
    background: transparent;
    border: 1px solid #60cb89;
    border-radius: 5px;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  input {
    background-color: transparent;
    outline: none;
    border: none;
    color: white;
    height: 100%;
    width: 100%;
  }
  .button {
    background-color: #60cb89;
    color: white;
    border-radius: 5px;
    padding: 7px 30px;
    width: fit-content;
    font-size: 16px;
    border: none;
    cursor: pointer;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s all;
    user-select: none;
  }
  .button:hover {
    background-color: #42a368;
  }
  .button.sm {
    padding: 3px 10px;
    font-size: 12px;
    margin-top: 0;
  }
  .button.red {
    background-color: #cb6060;
  }
  .button.red:hover {
    background-color: #a84a4a;
  }
  .modal-overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000000b3;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-box {
    background: #1d1d1d;
    width: 30rem;
    border-radius: 0.8rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
  }
</style>
